import Navigation from "../components/Navigation";
import Hero from "../components/Hero";
import About from "../components/About";
import Experience from "../components/Experience";
import Skills from "../components/Skills";
import Projects from "../components/Projects";
import Services from "../components/Services";
import Contact from "../components/Contact";

const Index = () => {
  return (
    <div
      className={`min-h-screen bg-background text-foreground relative overflow-x-hidden transition-colors duration-200`}
    >
      {/* Main Content */}
      <div className="relative z-10">
        <Navigation />
        <Hero />
        <About />
        <Experience />
        <Skills />
        {/* <Projects /> */}
        <Services />
        <Contact />
      </div>
    </div>
  );
};

export default Index;
